import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { 
    getProfilesRequest,
    getProfilesSuccess,
    getProfilesFailure,
    cleanGetProfiles as cleanGetProfilesReducer
} from "../reducers/profiles";
import { axiosClient } from "../config/axios";

export const getProfiles = () => (dispatch: Dispatch) => _getProfiles(dispatch);
const _getProfiles = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getProfilesRequest });

        const response = await axiosClient.get(`${api.users}/profiles`);

        dispatch({ 
            type: getProfilesSuccess, 
            payload: {
                profiles: response?.data?.data || response?.data,
                total: response?.data?.data?.length || response?.data?.length || 0
            }
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getProfilesFailure, payload: errorResponse });
    }
};

export const cleanGetProfiles = () => (dispatch: Dispatch) => _cleanGetProfiles(dispatch);
const _cleanGetProfiles = async (dispatch: Dispatch) => dispatch({type: cleanGetProfilesReducer});
